import script from "./AssetDetail.vue?vue&type=script&setup=true&lang=ts"
export * from "./AssetDetail.vue?vue&type=script&setup=true&lang=ts"

import "./AssetDetail.vue?vue&type=style&index=0&id=5e0872f3&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5e0872f3"]])

export default __exports__